import React, { FC, useEffect, useState } from 'react';

import Button from '../../../components/button/button';
import PDFViewer, { PdfMenu } from '../../../components/pdfViewer/PDFViewer';
import useReportGenerator from '../../../hooks/useReportGenerator';
import { FormModel, QuestionForm } from '../../../models/questionModel';
import { riskControlFormQuestions } from '../../../models/reportModel';
import {
  AssessingRiskManagementFrameworkIds,
  ControlEnvironmentAndActivitiesIds,
  InformationAndCommunicationIds,
  MonitoringIds,
  RiskControlQuestionIds,
  useReportStore,
} from '../../../store/ReportStore';
import { ReportHandler } from '../Report';
import styles from '../Report.module.scss';

const RiskControlReportSection: FC<ReportHandler> = ({ validChanged }) => {
  const { generateReportHook } = useReportGenerator('riskControlReport');
  const { riskControlReportPDF, controlReport, setRiskControlReportPDF } =
    useReportStore();

  const [riskControlForms, setRiskControlForms] = useState<FormModel[]>([]);
  const [menus, setMenus] = useState<PdfMenu[]>([]);

  useEffect(() => {
    setRiskControlReportPDF(null);

    const allQuestions = riskControlFormQuestions;
    const forms = allQuestions.map((quest) => {
      const form = new QuestionForm(quest.header);
      form.riskQuestions = quest.questions.map((q) => {
        const [questionId, questionSubId] = q.id.split('.');
        return {
          question: q.question,
          questionNotes: [],
          answer:
            controlReport[questionId as keyof RiskControlQuestionIds][
              questionSubId as keyof (
                | AssessingRiskManagementFrameworkIds
                | ControlEnvironmentAndActivitiesIds
                | InformationAndCommunicationIds
                | MonitoringIds
              )
            ],
          answerNotes: [],
        };
      });

      return form;
    });

    setRiskControlForms(forms);

    setMenus([
      {
        label: 'Generate Risk Control Report',
        callback: () => generateReport(forms),
      },
    ]);
  }, []);

  useEffect(() => {
    validChanged(riskControlReportPDF != null);
  }, [riskControlReportPDF]);

  const generateReport = (forms?: FormModel[]) => {
    generateReportHook(forms || riskControlForms);
  };

  return (
    <PDFViewer type="riskControlReport" menus={menus}>
      <Button onClick={() => generateReport()}>
        Generate Risk Control Report
      </Button>
    </PDFViewer>
  );
};

export default RiskControlReportSection;
